# Phase 5: Event delivery

The SEEK API’s [event] streams and webhook subscriptions replace [polling for advertisements] in the Job Posting API.
This enables your software to be notified of important events in a job ad’s lifecycle:

- A [`PositionProfilePosted` event] is emitted when a job ad goes live.
  In response you can [request fields from the position profile] such as the URL of the job ad.

- A [`PositionProfileClosed` event] is emitted when a job ad is closed.
  The Job Posting API refers to this as “expiry”.

For more information on setting up webhooks, see the [webhooks documentation].

## Exit criteria

To finalise your job posting migration, complete the following:

| Criteria                   | Description                                                                                                        |
| -------------------------- | ------------------------------------------------------------------------------------------------------------------ |
| Events received            | Your software successfully receives `PositionProfilePosted` events when SEEK hirers post job ads via the SEEK API. |
| SEEK job ad link displayed | Your software provides hirers with a link to view their posted job ad on the SEEK website.                         |

[event]: /events
[webhooks documentation]: /events/webhooks
[polling for advertisements]: /migration-guides/job-posting-api/phase-4-managing-job-ads#get-all-advertisements
[`positionprofileposted` event]: /use-cases/job-posting/managing-job-ads/posting-a-job-ad#positionprofileposted
[`positionprofileclosed` event]: /use-cases/job-posting/managing-job-ads/closing-a-job-ad#positionprofileclosed
[request fields from the position profile]: /use-cases/job-posting/managing-job-ads/querying-a-job-ad#positionprofile
